/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Animated, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle
} from "react-native";
import SVG_Svg, {
  ClipPath as SVG_ClipPath, Defs, G as SVG_G, GProps, Path as SVG_Path, PathProps
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const ClipPath = Animated.createAnimatedComponent(SVG_ClipPath);
const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"> <desc id="IMP.BLUE">{"#SubtractButton":{"type":"SELECTOR","constraint":"xMinYMin meet","width":20,"height":20},"#Group":{"type":"SELECTOR","constraint":"none","width":19.999958038330078,"height":19.999958038330078},"#Vector":{"type":"SELECTOR","constraint":"none","width":8.57148551940918,"height":1.4285526275634766},"transforms":{}}</desc>
 * <g id="SubtractButton" clip-path="url(#clip0)">
 * <g id="Group">
 * <g id="Group_2">
 * <path id="Vector" d="M16.4285 0H3.57141C1.59994 0.00234375 0.00234375 1.59994 0 3.57141V16.4285C0.00234375 18.4 1.59994 19.9976 3.57141 20H16.4285C18.4 19.9976 19.9976 18.4 20 16.4285V3.57141C19.9976 1.59994 18.4 0.00234375 16.4285 0ZM18.5714 16.4285C18.5714 17.612 17.612 18.5714 16.4285 18.5714H3.57141C2.38794 18.5714 1.42856 17.612 1.42856 16.4285V3.57141C1.42856 2.38794 2.38794 1.42856 3.57141 1.42856H16.4285C17.612 1.42856 18.5714 2.38794 18.5714 3.57141V16.4285Z" fill="#EDD4CB"/>
 * </g>
 * </g>
 * <path id="Vector_2" d="M13.5711 9.28571H10.7139H10.6305C10.6305 9.28571 10.3948 9.28575 10.0003 9.28575C9.60582 9.28575 9.46387 9.28572 9.46387 9.28572L9.28529 9.28571H6.42817C6.03366 9.28571 5.71387 9.6055 5.71387 10C5.71387 10.3945 6.03366 10.7143 6.42817 10.7143H9.28533C9.28533 10.7143 9.60582 10.7143 10.0003 10.7143C10.3948 10.7143 10.7139 10.7143 10.7139 10.7143H13.5711C13.9656 10.7143 14.2854 10.3945 14.2854 9.99996C14.2854 9.60546 13.9655 9.28571 13.5711 9.28571Z" fill="#D89F8B"/>
 * </g>
 * <defs>
 * <clipPath id="clip0">
 * <rect width="20" height="20" fill="white"/>
 * </clipPath>
 * </defs>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#SubtractButton": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 20,
 * 		"height": 20
 * 	},
 * 	"#Group": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 19.999958038330078,
 * 		"height": 19.999958038330078
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 8.57148551940918,
 * 		"height": 1.4285526275634766
 * 	},
 * 	"transforms": {}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const SubtractButton = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 20,
      height: 20,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  /** Component Internal State */

  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          {...props}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 20 20"
        >
          <G id="SubtractButton" clipPath="url(#clip0)">
            <Svg preserveAspectRatio="none" viewBox="0 0 20 20">
              <G id="Group">
                <G id="Group_2">
                  <Svg preserveAspectRatio="none" viewBox="0 0 20 20">
                    <Path
                      id="Vector"
                      d="M16.4285 0H3.57141C1.59994 0.00234375 0.00234375 1.59994 0 3.57141V16.4285C0.00234375 18.4 1.59994 19.9976 3.57141 20H16.4285C18.4 19.9976 19.9976 18.4 20 16.4285V3.57141C19.9976 1.59994 18.4 0.00234375 16.4285 0ZM18.5714 16.4285C18.5714 17.612 17.612 18.5714 16.4285 18.5714H3.57141C2.38794 18.5714 1.42856 17.612 1.42856 16.4285V3.57141C1.42856 2.38794 2.38794 1.42856 3.57141 1.42856H16.4285C17.612 1.42856 18.5714 2.38794 18.5714 3.57141V16.4285Z"
                      fill="#EDD4CB"
                      strokeWidth="1"
                      vectorEffect="non-scaling-stroke"
                    />
                  </Svg>
                </G>
              </G>
            </Svg>
            <Path
              id="Vector_2"
              d="M13.5711 9.28571H10.7139H10.6305C10.6305 9.28571 10.3948 9.28575 10.0003 9.28575C9.60582 9.28575 9.46387 9.28572 9.46387 9.28572L9.28529 9.28571H6.42817C6.03366 9.28571 5.71387 9.6055 5.71387 10C5.71387 10.3945 6.03366 10.7143 6.42817 10.7143H9.28533C9.28533 10.7143 9.60582 10.7143 10.0003 10.7143C10.3948 10.7143 10.7139 10.7143 10.7139 10.7143H13.5711C13.9656 10.7143 14.2854 10.3945 14.2854 9.99996C14.2854 9.60546 13.9655 9.28571 13.5711 9.28571Z"
              fill="#D89F8B"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </G>
          <Defs>
            <ClipPath id="clip0">
              <Path
                fill="white"
                id="clip0_elem0"
                d="M0 0 H20 a0,0 0 0 1 0,0 V20 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </ClipPath>
          </Defs>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 20"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G id="Group">
          <G id="Group_2">
            <Path
              id="Vector"
              d="M16.4285 0H3.57141C1.59994 0.00234375 0.00234375 1.59994 0 3.57141V16.4285C0.00234375 18.4 1.59994 19.9976 3.57141 20H16.4285C18.4 19.9976 19.9976 18.4 20 16.4285V3.57141C19.9976 1.59994 18.4 0.00234375 16.4285 0ZM18.5714 16.4285C18.5714 17.612 17.612 18.5714 16.4285 18.5714H3.57141C2.38794 18.5714 1.42856 17.612 1.42856 16.4285V3.57141C1.42856 2.38794 2.38794 1.42856 3.57141 1.42856H16.4285C17.612 1.42856 18.5714 2.38794 18.5714 3.57141V16.4285Z"
              fill="#EDD4CB"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </G>
        </G>
        <Defs>
          <ClipPath id="clip0">
            <Path
              fill="white"
              id="clip0_elem0"
              d="M0 0 H20 a0,0 0 0 1 0,0 V20 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </ClipPath>
        </Defs>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 20"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_2"
          d="M13.5711 9.28571H10.7139H10.6305C10.6305 9.28571 10.3948 9.28575 10.0003 9.28575C9.60582 9.28575 9.46387 9.28572 9.46387 9.28572L9.28529 9.28571H6.42817C6.03366 9.28571 5.71387 9.6055 5.71387 10C5.71387 10.3945 6.03366 10.7143 6.42817 10.7143H9.28533C9.28533 10.7143 9.60582 10.7143 10.0003 10.7143C10.3948 10.7143 10.7139 10.7143 10.7139 10.7143H13.5711C13.9656 10.7143 14.2854 10.3945 14.2854 9.99996C14.2854 9.60546 13.9655 9.28571 13.5711 9.28571Z"
          fill="#D89F8B"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <Defs>
          <ClipPath id="clip0">
            <Path
              fill="white"
              id="clip0_elem0"
              d="M0 0 H20 a0,0 0 0 1 0,0 V20 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(SubtractButton);
